<template>

<!--
<span>
  <button v-if="buttonStyle" type="button" class="btn-x" :class="buttonStyle.class" :disabled='disabled' @click="$emit('click')">
    <b-icon :icon="buttonStyle.icon"></b-icon>
    <span><slot>{{ buttonStyle.text }}</slot></span>
  </button>
</span>
-->

<!--button class="slide" :class="buttonStyle.class" :disabled='disabled' @click="$emit('click')">
    <div class="circle">
      <b-icon :icon="buttonStyle.icon"></b-icon>
    </div>
    <div class="text">{{ buttonStyle.text }}</div>
</button-->

<div class="t-button" :class="classes" @click="clicked">
    <div class="circle">
      <b-icon :icon="buttonStyle.icon"></b-icon>
    </div>
    <div class="text"><slot>{{ buttonStyle.text }}</slot></div>
</div>


</template>


<script>
export default {
  name: 't-button',
  props: {
    type: { default: "" },
    icon: { default: "" },
    disabled: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    
  },
  data: function() {
    return {
      /* buttonStyles : [
        { id: "ok", icon: "check-square-fill", class: "ok", text: this.$t('button.save') },
        { id: "save", icon: "check-square-fill", class: "ok", text: this.$t('button.save') },
        { id: "add", icon: "plus-square-fill", class: "ok", text: this.$t('button.add') },
        
        { id: "rm", icon: "dash-square-fill", class: "rm", text: this.$t('button.remove') },
        { id: "cancel", icon: "x-square-fill", class: "cancel", text: this.$t('button.cancel') },

        { id: "back", icon: "backspace-fill", class: "back", text: this.$t('button.back') },

        { id: "reload", icon: "arrow-clockwise", class: "ok", text: this.$t('button.refresh') },

        { id: "add-icon", icon: "plus-square-fill", class: "icon ok" },
        { id: "rm-icon", icon: "dash-square-fill", class: "icon rm" },
        { id: "icon", class: "icon" },
      ],*/
      buttonStyles : [
        { id: "ok", icon: "check-lg", class: "ok", text: this.$t('button.save') },
        { id: "save", icon: "check-lg", class: "ok", text: this.$t('button.save') },
        { id: "add", icon: "plus-lg", class: "ok", text: this.$t('button.add') },
        
        { id: "rm", icon: "x-lg", class: "rm", text: this.$t('button.remove') },
        { id: "cancel", icon: "x-square-fill", class: "cancel", text: this.$t('button.cancel') },

        { id: "back", icon: "backspace-fill", class: "back", text: this.$t('button.back') },

        { id: "reload", icon: "arrow-clockwise", class: "ok", text: this.$t('button.refresh') },

        { id: "add-icon", icon: "plus-lg", class: "icon ok" },
        { id: "rm-icon", icon: "dash-square-fill", class: "icon rm" },
        { id: "icon", class: "icon" },
      ],


      buttonStyle: null
    }
  },
  created(){
    this.buttonStyle = this.findButtonStyle(this.type)
  },
  computed: {
    classes(){
      let buttonClasses = this.buttonStyle.class;
      if(this.right) buttonClasses += " float-right"
      if(this.disabled) buttonClasses += " disabled"
       if(this.small) buttonClasses += " small"
      return buttonClasses;
    }
  },
  methods: {
    findButtonStyle(type){
      let style = this.buttonStyles.find(style => style.id == type);
      if(!style)
        style = {  icon: "", class: type }

      if(this.icon) style.icon = this.icon;

      return style;
    },
    clicked(){
      if(!this.disabled)
        this.$emit('click')
    }
  } 

} 
</script>

<style scoped lang="scss"></style>